import { Pipe, PipeTransform } from "@angular/core";
import { SituacaoDadosGrid } from "app/shared/enums/situacao-dados-grid.enum";

@Pipe({
    name: "iconeSituacaoValidade",
})
export class IconeSituacaoValidade implements PipeTransform {

    icons: Array<any> = [
        { icon: 'cancel', color: '#CB4335', value: SituacaoDadosGrid.INEXISTENTE },
        { icon: 'remove_circle', color: '#808080', value: SituacaoDadosGrid.INVALIDO },
        { icon: 'check_circle', color: '#28B463', value: SituacaoDadosGrid.VALIDO },
    ]

    transform(value: number, prop: string) {
        if (isNaN(value) || !prop)
            return;
        
        return this.icons.find(icon => icon.value === value)[prop];
    }
}
